<script>
import { ref } from 'vue';
import { mapGetters } from "vuex";
import { scroller } from "vue-scrollto/src/scrollTo";
import { mapFields } from "vuex-map-fields";
import _ from 'lodash';
import { GetContributionScenario } from 'lifetime-contributions-calculator-engine'
import { BrowserEngine } from 'super-engine';

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBModal,
  MDBModalBody,
} from "mdb-vue-ui-kit";

import clientConfig from '/src/config/client';

export const superEngine = new BrowserEngine();

export default {
  name: "ResultPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBModal,
    MDBModalBody,
  },

  setup() {
    const detailsModal = ref(false);
    const graphModal = ref(false);
    return {
      detailsModal,
      graphModal,
    };
  },

  data() {
    return {
      clientConfig,
      contributionEngineResultCurrent: null,
      contributionEngineResult: null,
      superEngineResult: null,
      superEngineResultWithUpdatedContributions: null,
    }
  },

  computed: {
     ...mapFields([
      "age",
      "superannuationBalance",
      "employerContributionRate",
      "memberType",
      "taxedFund",
      "superEngineConfig",
      "spareCashAmountFrequency",
    ]),

    ...mapGetters([
      "debugMode",
      "activeTab",
      "annualSalary",
      "annualSpareCashAmount",
      "annualContributionsAfterTax",
      "annualContributionsBeforeTax",
    ])
  },

  watch: {
    // Whenever tab changes, this function will check
    activeTab(tabVal) {
      if (tabVal === 4) {
        this.runEngine();
      }
    }
  },

  methods: {
    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ccApp");

      this.triggerHeightCheck();

      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });

      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    },

    splitAnnualAmountToFrequency(amount,frequency) {
      var splitAmount = amount //default is yearly amount

      switch(frequency) {
        case "week":
          splitAmount = amount * clientConfig.params.frequency.week
          break;
        case "fortnight":
            splitAmount = amount * clientConfig.params.frequency.fortnight
          break;
        case "month":
            splitAmount = amount * clientConfig.params.frequency.month
          break;
      }
      return splitAmount
    },

    editAssumptions() {
      this.$store.commit("setActiveTab", 6);
      this.$store.commit("setIsEditingAssumptions", true);
    },

    runContributionEngine(inputData) {
      var response = GetContributionScenario("Single", inputData, true);
      return response;
    },

    runSuperEngineWithContributions(PreTaxMemberContributions, PostTaxMemberContributions) {
      var updatedSuperEngineConfig =  _.cloneDeep(this.superEngineConfig);

      const now = new Date();
      updatedSuperEngineConfig.CalculationDate = ('' + now.getDate()).padStart(2, '0') + '/' +
        ('' + (now.getMonth() + 1)).padStart(2, '0') + '/' +
        now.getFullYear();

      updatedSuperEngineConfig.PreTaxMemberContributions = PreTaxMemberContributions;
      updatedSuperEngineConfig.PostTaxMemberContributions = PostTaxMemberContributions;

      if (this.debugMode)
        console.log("SuperEngine Input Object With Contributions -->", updatedSuperEngineConfig);

      superEngine.setDefaults(updatedSuperEngineConfig);
      var superEngineResponseWithContributions = superEngine.runSync();

      if (this.debugMode)
        console.log("SuperEngine Result Object With Contributions -->", superEngineResponseWithContributions);

      return superEngineResponseWithContributions;
    },

    runEngine() {
      // SINGLE
      // {
      //   "SpareCashflow": 000,
      //   "IncludeCurrentVoluntaryContributionsInSpareCashflow": true,
      //   "TaxedFund": true,
      //   "AnnualSalary": 000,
      //   "SuperannuationBalance": 000,
      //   "EmployerContributionRate": 0.105,
      //   "CurrentVoluntaryConcessionalContributions": 0,
      //   "CurrentVoluntaryNonConcessionalContributions": 0
      // }

      // COUPLE
      // {
      //   "SpareCashflow": 0,
      //   "IncludeCurrentVoluntaryContributionsInSpareCashflow": true,
      //   "PersonOne_AnnualSalary": 000,
      //   "PersonTwo_AnnualSalary": 000,
      //   "PersonOne_SuperannuationBalance": 000,
      //   "PersonTwo_SuperannuationBalance": 000,
      //   "PersonOne_EmployerContributionRate": 0.105,
      //   "PersonTwo_EmployerContributionRate": 0.105,
      //   "PersonOne_CurrentVoluntaryConcessionalContributions": 0,
      //   "PersonTwo_CurrentVoluntaryConcessionalContributions": 0,
      //   "PersonOne_CurrentVoluntaryNonConcessionalContributions": 0,
      //   "PersonTwo_CurrentVoluntaryNonConcessionalContributions": 0
      // }

      this.contributionEngineResultCurrent = this.runContributionEngine({
        "SpareCashflow": this.annualSpareCashAmount,
        "IncludeCurrentVoluntaryContributionsInSpareCashflow": false,
        "TaxedFund": this.taxedFund,
        "AnnualSalary": this.annualSalary,
        "SuperannuationBalance": this.superEngineConfig.SuperannuationBalance,
        "EmployerContributionRate": this.employerContributionRate/100,
        "CurrentVoluntaryConcessionalContributions": this.annualContributionsBeforeTax,
        "CurrentVoluntaryNonConcessionalContributions": this.annualContributionsAfterTax
      });

      this.contributionEngineResult = this.runContributionEngine({
        "SpareCashflow": this.annualSpareCashAmount,
        "IncludeCurrentVoluntaryContributionsInSpareCashflow": true,
        "TaxedFund": this.taxedFund,
        "AnnualSalary": this.annualSalary,
        "SuperannuationBalance": this.superEngineConfig.SuperannuationBalance,
        "EmployerContributionRate": this.employerContributionRate/100,
        "CurrentVoluntaryConcessionalContributions": this.annualContributionsBeforeTax,
        "CurrentVoluntaryNonConcessionalContributions": this.annualContributionsAfterTax
      });

      this.superEngineResultWithCurrentContributions = this.runSuperEngineWithContributions(this.$roundTo(this.annualContributionsBeforeTax), this.$roundTo(this.annualContributionsAfterTax));
      this.superEngineResultWithUpdatedContributions = this.runSuperEngineWithContributions(this.$roundTo(this.contributionEngineResult.AdditionalConcessionalContributions), this.$roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions));

      if (this.debugMode) {
        console.log('contributions engine result (current):', this.contributionEngineResultCurrent);
        console.log('contributions engine result:', this.contributionEngineResult);
        console.log('super engine result:', this.superEngineResultWithUpdatedContributions);
        console.log(
          "Age", this.age, "|",
          "AnnualSalary", this.annualSalary, "|",
          "SpareCashflow", this.annualSpareCashAmount,"|",
          "SuperannuationBalance", this.superEngineConfig.SuperannuationBalance,"|",
          "EmployerContributionRate", this.employerContributionRate,"|",
          "MemberType", this.memberType, "|",
          "TaxedFund", this.taxedFund, "|",
          "CurrentVoluntaryConcessionalContributions", this.annualContributionsBeforeTax,"|",
          "CurrentVoluntaryNonConcessionalContributions", this.annualContributionsAfterTax
        )
      }

      // this.superEngineConfig.MemberType = selectedMemberType;


      // Log Analytics

      //------------------------
      this.$gtag.event('data', {
        'event_category': 'userInput',
        'event_label': 'userAge' + this.age,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: userAge" + this.age);
      //------------------------
      this.$gtag.event('data', {
        'event_category': 'userInput',
        'event_label': 'userSalary' + this.annualSalary,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: userSalary" + this.annualSalary);

      //------------------------
      this.$gtag.event('data', {
        'event_category': 'userInput',
        'event_label': 'userSpareCashflow' + this.annualSpareCashAmount,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: userSpareCashflow" + this.annualSpareCashAmount);
      //------------------------
      this.$gtag.event('data', {
        'event_category': 'userInput',
        'event_label': 'userSuperannuationBalance' + this.superEngineConfig.SuperannuationBalance,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: userSuperannuationBalance" + this.superEngineConfig.SuperannuationBalance);
      //------------------------
      this.$gtag.event('data', {
        'event_category': 'userInput',
        'event_label': 'userEmployerContributionRate' + this.employerContributionRate,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: userEmployerContributionRate" + this.employerContributionRate);
      //------------------------
      this.$gtag.event('data', {
        'event_category': 'userInput',
        'event_label': 'userMemberType' + this.superEngineConfig.MemberType,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: userMemberType" + this.superEngineConfig.MemberType);
      //------------------------
      this.$gtag.event('data', {
        'event_category': 'userInput',
        'event_label': (this.taxedFund ? 'userTaxedFund' : 'userUntaxedFund'),
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: userTaxedFund" + this.taxedFund);
      //------------------------
      this.$gtag.event('data', {
        'event_category': 'userInput',
        'event_label': 'userCurrentVoluntaryConcessionalContributions' + this.$roundTo(this.annualContributionsBeforeTax),
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: userCurrentVoluntaryConcessionalContributions" + this.$roundTo(this.annualContributionsBeforeTax));
      //------------------------
      this.$gtag.event('data', {
        'event_category': 'userInput',
        'event_label': 'userCurrentVoluntaryNonConcessionalContributions' + this.$roundTo(this.annualContributionsAfterTax),
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: userCurrentVoluntaryNonConcessionalContributions" + this.$roundTo(this.annualContributionsAfterTax));
      //------------------------

    }
  },

  mounted() {
    this.triggerHeightCheck();

    this.contributionEngineResultCurrent = this.runContributionEngine({
      "IncludeCurrentVoluntaryContributionsInSpareCashflow": false,
      "TaxedFund": this.taxedFund,
      "AnnualSalary": this.annualSalary,
      "SuperannuationBalance": this.superEngineConfig.SuperannuationBalance,
      "EmployerContributionRate": this.employerContributionRate/100,
      "CurrentVoluntaryConcessionalContributions": this.annualContributionsBeforeTax,
      "CurrentVoluntaryNonConcessionalContributions": this.annualContributionsAfterTax
    });

    this.contributionEngineResult = this.runContributionEngine({
      "SpareCashflow": this.annualSpareCashAmount,
      "IncludeCurrentVoluntaryContributionsInSpareCashflow": true,
      "TaxedFund": this.taxedFund,
      "AnnualSalary": this.annualSalary,
      "SuperannuationBalance": this.superEngineConfig.SuperannuationBalance,
      "EmployerContributionRate": this.employerContributionRate/100,
      "CurrentVoluntaryConcessionalContributions": this.annualContributionsBeforeTax,
      "CurrentVoluntaryNonConcessionalContributions": this.annualContributionsAfterTax
    });

    // this.superEngineResultWithCurrentContributions = this.runSuperEngine();
    this.superEngineResultWithCurrentContributions = this.runSuperEngineWithContributions(this.$roundTo(this.annualContributionsBeforeTax), this.$roundTo(this.annualContributionsAfterTax));
    this.superEngineResultWithUpdatedContributions = this.runSuperEngineWithContributions(this.$roundTo(this.contributionEngineResult.AdditionalConcessionalContributions), this.$roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions));

    if (this.debugMode) {
      console.log('contributions (current) engine result:', this.contributionEngineResultCurrent);
      console.log('contributions engine result:', this.contributionEngineResult);
      console.log('super engine result:', this.superEngineResultWithUpdatedContributions);
      console.log(
        "Age", this.age, "|",
        "AnnualSalary", this.salary, "|",
        "SpareCashflow", this.spareCashAmount,"|",
        "SuperannuationBalance", this.superEngineConfig.SuperannuationBalance,"|",
        "EmployerContributionRate", this.employerContributionRate,"|",
        "CurrentVoluntaryConcessionalContributions", this.contributionsBeforeTax,"|",
        "CurrentVoluntaryNonConcessionalContributions", this.contributionsAfterTax
      )
    }

    if (this.debugMode)
      console.log("SuperEngine Input Object -->", this.superEngineConfig);

    // AbsLifeTable: {startAge: 0, male: Array(101), female: Array(101)}
    // AccountType: 1
    // AccountType_2: 1
    // AccruedDBMultiple: 0
    // AccruedDBMultiple_2: 0
    // AccumulationMemberCoreContributionRate: 0
    // AccumulationMemberCoreContributionRate_2: 0
    // ActiveSuper_FemaleDeathPerUnitPerMonth: 0.658
    // ActiveSuper_FemaleTPDPerUnitPerMonth: 0.553
    // ActiveSuper_MaleDeathPerUnitPerMonth: 0.854
    // ActiveSuper_MaleTPDPerUnitPerMonth: 0.444
    // AgeNow: "40"
    // AgeNowCompletedPartYear: 0
    // AgeNowCompletedPartYear_2: 0
    // AgeNow_2: 35
    // AgePensionAllowCouplePensions: true
    // AlternateLifeTable: {startAge: 50, male: Array(50), female: Array(50)}
    // AssetTestLowerThresholdCoupleHomeowner: 419000
    // AssetTestLowerThresholdCoupleNonHomeowner: 643500
    // AssetTestLowerThresholdSingleHomeowner: 280000
    // AssetTestLowerThresholdSingleNonHomeowner: 504500
    // AssetTestUpperThresholdCoupleHomeowner: 915500
    // AssetTestUpperThresholdCoupleNonHomeowner: 1140000
    // AssetTestUpperThresholdSingleHomeowner: 609250
    // AssetTestUpperThresholdSingleNonHomeowner: 833750
    // CalculationDate: "01/07/2022"
    // CoContributionLowerThreshold: 42016
    // CoContributionUpperThreshold: 57016
    // ConcessionalContributionThreshold: 28504
    // ContributionRateSubsequentEmployment: 0
    // ContributionRateSubsequentEmployment_2: 0
    // CurrentMaximumCoContribution: 500
    // DBMemberCoreContributionRate: 0
    // DBMemberCoreContributionRate_2: 0
    // Debug: false
    // DeemingRateHigherIncome: 0.0225
    // DeemingRateLowerIncome: 0.0025
    // DeemingThresholdCouple: 93600
    // DeemingThresholdSingle: 56400
    // DeferredRetirementBalance: 0
    // DeferredRetirementBalance_2: 0
    // EmployerAccrualTable: {rate_1: {…}, rate_2: {…}, rate_3: {…}, rate_4: {…}, rate_5: {…}, …}
    // EmployerContributionRate: 0.1
    // EmployerContributionRate_2: 0.1
    // EmployerContributionTable: {rate_1: {…}, rate_2: {…}, rate_3: {…}, rate_4: {…}, rate_5: {…}, …}
    // EnforceMaximumContributionBase: false
    // EnforceMinimumDrawingRequirements: true
    // EquipDeathCoverTaper: {startAge: 0, cost: Array(0)}
    // EquipDeathPremiums: {startAge: 0, cost: Array(0)}
    // EquipInsurancePremium: -1
    // EquipInsurancePremiumSteps: {startAge: 0, cost: Array(0)}
    // EquipTPDCoverTaper: {startAge: 0, cost: Array(0)}
    // EquipTPDPremiums: {startAge: 0, cost: Array(0)}
    // FSSInsurancePremium: 243
    // FutureYearsCurrentEmployment: 0
    // FutureYearsCurrentEmployment_2: 0
    // GovernmentIncomeProtectionTable: {startAge: 16, cost: Array(50)}
    // HighIncomeEarningThreshold: 250000
    // HomeOwner: true
    // InTodaysTerms: true
    // IncludeAgePension: true
    // IncludeCoContributions: 0
    // IncludePartner: false
    // IncludeTTR: false
    // IncomeProtectionInsurancePremium: 0
    // IncomeTaxRates: {band_0: {…}, band_1: {…}, band_2: {…}, band_3: {…}, band_4: {…}}
    // IncomeTaxRates_2022: {band_0: {…}, band_1: {…}, band_2: {…}, band_3: {…}, band_4: {…}}
    // IncomeTaxRates_2024: {band_0: {…}, band_1: {…}, band_2: {…}, band_3: {…}}
    // IncomeTestLowerThresholdCouple: 336
    // IncomeTestLowerThresholdSingle: 190
    // IncomeTestUpperThresholdCouple: 3313.6
    // IncomeTestUpperThresholdSingle: 2165.2
    // InitialExternalPension: 0
    // InitialExternalPension_2: 0
    // InsurancePremium: 468
    // InvestmentOption: 3
    // InvestmentOptionInRetirement: 3
    // InvestmentOptionInRetirement_2: 3
    // InvestmentOption_2: 3
    // InvestmentOptions: {investmentOption_0: {…}, investmentOption_1: {…}, investmentOption_2: {…}, investmentOption_3: {…}, investmentOption_4: {…}, …}
    // LITOLowerThreshold: 37000
    // LITOUpperThreshold: 66666
    // LITO_2022_HighIncomeThreshold: 66667
    // LITO_2022_InitialPhaseOutRate: 0.05
    // LITO_2022_LowIncomeThreshold: 37500
    // LITO_2022_LowPaymentRate: 325
    // LITO_2022_MaxPaymentRate: 700
    // LITO_2022_MiddleIncomeThreshold: 45000
    // LITO_2022_SubsequentPhaseOutRate: 0.015
    // LMITO_HighIncomeThreshold: 126000
    // LMITO_LowPaymentRate: 255
    // LMITO_LowRateLowIncomeThreshold: 37000
    // LMITO_MaxPaymentRate: 1080
    // LMITO_MaxRateHighIncomeThreshold: 90000
    // LMITO_MaxRateLowIncomeThreshold: 48000
    // LMITO_PhaseInRate: 0.075
    // LMITO_PhaseOutRate: 0.03
    // LowIncomeEarnersGovernmentContributionIncomeThreshold: 37000
    // LowIncomeEarnersGovernmentContributionMaximum: 500
    // Married: true
    // MaximumContributionBase: 1000
    // MaximumLITO: 445
    // MaximumLITO_2022: 645
    // MaximumSATO: 2230
    // MaximumSATOCouple: 1602
    // MedicareLowerThreshold: 23365
    // MedicarePhasingInRate: 0.1
    // MedicareRate: 0.02
    // MedicareUpperThreshold: 29206
    // MemberType: 0
    // MemberType_2: 0
    // NonConcessionalContributionThreshold: 114016
    // NonGovernmentIncomeProtectionTable: {startAge: 16, cost: Array(50)}
    // OneOffContribution: 0
    // OneOffContributionMadeAtAge: 40
    // OneOffContributionMadeAtAge_2: 0
    // OneOffContribution_2: 0
    // OtherAssets: 0
    // OtherIncome: 0
    // Output: true
    // PartTimeWorkDaysPerWeek: 0
    // PartTimeWorkDaysPerWeek_2: 0
    // PartTimeWorkFromAge: 40
    // PartTimeWorkFromAge_2: 0
    // PartTimeWorkYearsDuration: 0
    // PartTimeWorkYearsDuration_2: 0
    // PensionCouple: 679
    // PensionSingle: 900.8
    // PensionSupplementCoupleMaximum: 65.4
    // PensionSupplementCoupleMinimum: 40.1
    // PensionSupplementSingleMaximum: 86.8
    // PensionSupplementSingleMinimum: 53.2
    // PensionTransferBalanceCap: 1794027
    // PoliceIncomeProtectionTable: {startAge: 16, cost: Array(45)}
    // PostTaxContributions: true
    // PostTaxContributions_2: true
    // PostTaxMemberContributions: 0
    // PostTaxMemberContributions_2: 0
    // PreTaxMemberContributions: 0
    // PreTaxMemberContributions_2: 0
    // PriceInflationIndex: [0.025]
    // QSuperDeathTPDDefault: {startAge: 16, cost: Array(54)}
    // QSuperDeathTPDPolice: {startAge: 16, cost: Array(46)}
    // QSuperDefaultInsuranceUnitsGovernment: 3
    // QSuperDefaultInsuranceUnitsNonGovernment: 2
    // RetirementAge: 65
    // RetirementAge_2: 65
    // RollOverAge: 0
    // RollOverAge_2: 0
    // RollOverAmount: 0
    // RollOverAmount_2: 0
    // SATOLowerThreshold: 32279
    // SATOLowerThresholdCouple: 28974
    // SATOUpperThreshold: 50119
    // SATOUpperThresholdCouple: 41790
    // SGCMaximumContributionBase: 60220
    // Salary: 70000
    // Salary_2: 10000
    // SeniorSupplementCouple: 647.4
    // SeniorSupplementIncomeThresholdCouple: 80000
    // SeniorSupplementIncomeThresholdSingle: 50000
    // SeniorSupplementSingle: 858
    // Sex: "Female"
    // Sex_2: "Male"
    // SunSuperDeathTPDFemale: {startAge: 15, cost: Array(55)}
    // SunSuperDeathTPDMale: {startAge: 15, cost: Array(55)}
    // SunSuperTargetIncomeInflationInRetirement: 0.03
    // SunSuper_10: {startAge: 55, male: Array(21), female: Array(21)}
    // SunSuper_50: {startAge: 55, male: Array(21), female: Array(21)}
    // SuperannuationBalance: 100000
    // SuperannuationBalance_2: 0
    // TargetIncome: 50000
    // Testing: false
    // UntaxedComponent: 0
    // UntaxedComponent_2: 0
    // UntaxedPlanCapAmount: 1650000
    // VisionIPSalaryThreshold: 0
    // VisionIncomeProtection: {startAge: 16, cost: Array(50)}
    // VisionTPD: 223.85
    // WageInflationIndex: [0.035]
    // WithdrawalAtRetirement: 0
    // WithdrawalAtRetirement_2: 0
    // WorkBonus: 300

  }
};
</script>

<template>
  <MDBContainer fluid class="p-0">
    <MDBRow class="p-0">
      <MDBCol
        col="12"
      >
        <MDBCol md="11" class=" text-left mx-auto">
          <div v-html="clientConfig.content.calculation.header"></div>
          <div v-html="clientConfig.content.calculation.content"></div>
        </MDBCol>

        <div class="mx-auto">
          <section v-if="this.contributionEngineResult && this.superEngineResultWithCurrentContributions && this.superEngineResultWithUpdatedContributions">
            <MDBRow class="g-0">
              <MDBCol xs="12" lg="8">
                <div class="panel main-panel text-center">
                  <div class="card main-card" tabindex="0" role="text">
                    <div class="main-descriptor">
                      <strong>
                        {{ clientConfig.content.calculation.comparisonHeading }}
                      </strong>
                    </div>

                    <div class="number">
                      <span class="white-text">
                        {{ clientConfig.content.calculation.contributeText }}
                      </span>
                      <MDBRow class="number-banner">
                        <MDBCol v-if="$roundTo(this.contributionEngineResult.AdditionalConcessionalContributions) > 0">
                          <strong class="figure">
                            ${{ $formatCurrency($roundTo( splitAnnualAmountToFrequency(this.contributionEngineResult.AdditionalConcessionalContributions, this.spareCashAmountFrequency )), false) }}
                            <!-- split by freq -->
                            / {{this.spareCashAmountFrequency}}
                          </strong>
                          <br />
                          <span v-html="clientConfig.content.calculation.beforeTaxContributionsText"></span>
                        </MDBCol>

                        <MDBCol v-if="$roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions) > 0 && $roundTo(this.contributionEngineResult.AdditionalConcessionalContributions) > 0">
                          <strong class="plus white-text">+</strong>
                        </MDBCol>

                        <MDBCol v-if="$roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions) > 0">
                          <strong class="figure">
                            ${{ $formatCurrency($roundTo( splitAnnualAmountToFrequency(this.contributionEngineResult.AdditionalNonConcessionalContributions, this.spareCashAmountFrequency)), false) }}
                            <!-- split by freq -->
                            / {{this.spareCashAmountFrequency}}
                          </strong>
                          <br />
                          <span v-html="clientConfig.content.calculation.afterTaxContributionsText"></span>
                        </MDBCol>
                      </MDBRow>
                    </div>
                    <div class="components">
                      <span>
                        <span v-if="this.contributionEngineResult.TaxSavings > 0 || $roundTo(this.contributionEngineResult.CoContributionsBasedOnAdditionalContributions) > 0 ">
                          {{ clientConfig.content.calculation.benefitsText }}
                        </span>
                      </span>
                      <MDBRow>
                        <MDBCol v-if="this.contributionEngineResult.TaxSavings > 0">
                          <div class="product-icon teal">
                            <i><img src="@/assets/images/tax-icon.svg" alt=""></i>
                          </div>
                          <p>
                            <span>
                              ${{ $formatCurrency($roundTo(this.contributionEngineResult.TaxSavings), false) }}
                              / year
                            </span>
                            <br />
                            {{ clientConfig.content.calculation.taxSavingsText }}
                          </p>
                        </MDBCol>

                        <MDBCol v-if="$roundTo(this.contributionEngineResult.CoContributionsBasedOnAdditionalContributions) > 0">
                          <div class="product-icon coral">
                            <i><img src="@/assets/images/contributions-icon.svg" alt=""></i>
                          </div>
                          <p>
                            <span>
                              ${{ $formatCurrency($roundTo(this.contributionEngineResult.CoContributionsBasedOnAdditionalContributions), false) }}
                              / year
                            </span>
                            <br />
                            {{ clientConfig.content.calculation.coContText }}
                          </p>
                        </MDBCol>

                        <!-- <MDBCol>
                          <div class="product-icon green">
                            <i><img src="@/assets/images/contributions-icon.svg" alt=""></i>
                          </div>
                          <p>
                            <span>
                              $100 / year
                            </span>

                            <br />
                            {{ clientConfig.content.calculation.lowIncomeText }}
                          </p>
                        </MDBCol>  -->

                      </MDBRow>

                      <MDBRow class="description" v-if="$roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions) > 0">

                        <MDBCol>
                          <p class="dark-txt">
                            <!-- Your new take home pay will be around  -->
                            <!-- ${{ $formatCurrency(this.contributionEngineResult.AfterTaxSalaryWithAdditionalVoluntaryContributions, false) }}  -->
                            <span>
                              You will need to contribute an after-tax contribution of
                              ${{ $formatCurrency($roundTo( splitAnnualAmountToFrequency(this.contributionEngineResult.AdditionalNonConcessionalContributions, this.spareCashAmountFrequency)), false) }}
                              <!-- split freq -->
                              / {{this.spareCashAmountFrequency}} from your after-tax income.
                            </span>
                          </p>

                          <!-- <p class="lg-txt">
                            <span v-if="$roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributionsFromResidualCashflow) > 0" v-html="clientConfig.content.calculation.exceededConcessionalCap"></span>
                            <span v-else v-html="clientConfig.content.calculation.notExceededConcessionalCap"></span>
                            <br />
                            <a :href="clientConfig.content.calculation.concessionalCapLearnMoreLink">
                              {{ clientConfig.content.calculation.concessionalCapLearnMoreText }}
                            </a>
                          </p> -->

                          <br />

                          <!-- <MDBBtn
                            color="primary"
                            aria-controls="graphModal"
                            @click="graphModal = true"
                            class="results-btn"
                          >
                            {{ clientConfig.content.calculation.seeContributionDetailsButton }}
                          </MDBBtn> -->
                        </MDBCol>
                      </MDBRow>
                    </div>
                  </div>
                </div>
              </MDBCol>

              <MDBCol xs="12" lg="4">
                <div class="panel side-panel">
                  <div class="arrow-right d-none d-lg-flex"></div>
                  <div class="take-home-pay" tabindex="0" role="text">
                    <div class="panel-wrapper">
                      <span class="light-text" v-html="clientConfig.content.calculation.totalAdditionalContributionBenefitHeader"></span>
                      <br />
                      <p class="figure extra-padding">
                        ${{ $formatCurrency((
                          $roundTo(this.contributionEngineResult.AdditionalConcessionalContributions) +
                          $roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions) +
                          $roundTo(this.contributionEngineResult.CoContributionsBasedOnAdditionalContributions)
                          ) , false) }}
                        / year
                      </p>
                      <br />
                      <MDBBtn
                        color="primary"
                        aria-controls="detailsModal"
                        @click="detailsModal = true"
                        class="results-btn green"
                      >
                        {{ clientConfig.content.calculation.sideBySideComparisonButton }}
                      </MDBBtn>
                    </div>
                  </div>

                  <div class="extra-super mb-5" tabindex="0" role="text">
                    <div class="panel-wrapper">
                      <p>
                        <strong>
                        <span v-html="clientConfig.content.calculation.superAtAgeHeader"></span>
                        {{this.superEngineResultWithCurrentContributions.engineResults.subjectRetirementAge}}
                        </strong>
                      </p>

                      <p class="highlight">
                        {{ clientConfig.content.calculation.withtAdditionalContributionsText }}
                      </p>

                      <p class="figure highlight">
                          ${{ $formatCurrency((
                          $roundTo(this.superEngineResultWithUpdatedContributions.deflatedCombinedBalanceAtRetirement)
                        ) , false) }}
                      </p>

                      <div class="in-box highlight">
                        {{ clientConfig.content.calculation.comparisonAdditionalContributionsText }}
                        <br/>
                        <div class="figure">
                          ${{ $formatCurrency((
                            $roundTo(this.superEngineResultWithUpdatedContributions.deflatedCombinedBalanceAtRetirement) - $roundTo(this.superEngineResultWithCurrentContributions.deflatedCombinedBalanceAtRetirement)
                          ) , false) }}

                          <span>({{ $roundTo((this.superEngineResultWithUpdatedContributions.deflatedCombinedBalanceAtRetirement - this.superEngineResultWithCurrentContributions.deflatedCombinedBalanceAtRetirement)/this.superEngineResultWithCurrentContributions.deflatedCombinedBalanceAtRetirement * 100) }}%)</span>
                        </div>

                      </div>

                      <p>
                        {{ clientConfig.content.calculation.withoutAdditionalContributionsText }}
                      </p>

                      <p class="figure-teal">
                        ${{ $formatCurrency((
                          $roundTo(this.superEngineResultWithCurrentContributions.deflatedCombinedBalanceAtRetirement)
                        ) , false) }}
                      </p>
                    </div>
                  </div>

                  <div class="edit-assumptions">
                    <div class="panel-wrapper p-2">
                      <small>
                        <a @click="editAssumptions()" tabindex="0">
                          {{ clientConfig.content.calculation.editAssumptionsButton }}
                        </a>
                      </small>
                    </div>
                  </div>
                </div>

              </MDBCol>
            </MDBRow>
          </section>
        </div>

        <MDBRow>
          <MDBCol
            md="11"
            class=" text-center mx-auto my-5"
          >
            <MDBBtn
              outline="secondary"
              class="rounded me-2"
              @click="clickToTab(3)"
              aria-label="Back button"
            >
              {{ clientConfig.content.calculation.backButtonLabel }}
            </MDBBtn>

            <MDBBtn
              color="primary"
              class="rounded next"
              @click="clickToTab(5)"
              aria-label="Continue button"
            >
              {{ clientConfig.content.calculation.nextButtonLabel }}
              <i class="fas icon-arrow"></i>
            </MDBBtn>
          </MDBCol>
        </MDBRow>

      </MDBCol>
    </MDBRow>

    <MDBModal
      id="detailsModal"
      tabindex="-1"
      labelledby="detailsModalLabel"
      v-model="detailsModal"
    >
      <MDBModalBody class="details-modal">
        <!-- <h3>How this could impact you</h3> -->
        <!-- <p>By following the contribution strategy, you may be eligible to receive these benefits:</p>
        <table class="table benefit-table">
          <thead>
            <tr>
              <th scope="col"><strong>Benefits</strong></th>
              <th scope="col"><strong>$ </strong></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Super growth (p.a.)</td>
              <td>$8,525</td>
            </tr>
            <tr>
              <td>Before tax contribution (p.a.)</td>
              <td>($8,525) as salary sacrifice</td>
            </tr>
            <tr>
              <td>Tax savings (p.a.)</td>
              <td>$1,700</td>
            </tr>
            <tr>
              <td>Government co-contribution (p.a.)</td>
              <td>$600</td>
            </tr>
            <tr>
              <td>Total retirement balance increase</td>
              <td>$40,000</td>
            </tr>
              <tr>
              <td>Government co-contribution (p.a.)</td>
              <td>$600</td>
            </tr>
          </tbody>
        </table> -->

        <h3>Comparative breakdown</h3>
        <h4>based on a contribution of
        <strong v-if="this.contributionEngineResult.AdditionalConcessionalContributions > 0">
        ${{ $formatCurrency($roundTo(this.contributionEngineResult.AdditionalConcessionalContributions), false) }}
        / year before tax
        </strong>

        <span
          v-if="this.contributionEngineResult.AdditionalNonConcessionalContributions > 0 &&
          this.contributionEngineResult.AdditionalConcessionalContributions > 0"
        > and </span>

        <strong v-if="this.contributionEngineResult.AdditionalNonConcessionalContributions > 0">
          ${{ $formatCurrency($roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions), false) }}
          / year after tax</strong>.</h4>
        <!-- <p>Funds that can't be contributed to superannuation due to transfer balance cap threshold. (todo)</p> -->
        <div class="table-responsive mb-4">
          <table class="table benefit-table">
            <thead>
              <tr>
                <th scope="col"><strong>Super ($ per annum)</strong></th>
                <th scope="col"><strong>With current contributions</strong></th>
                <th scope="col"><strong>With updated contributions</strong></th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Employer contributions</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResultCurrent.EmployerConcessionalContributions), false) }} / year</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResult.EmployerConcessionalContributions), false) }} / year</td>
              </tr>
              <tr>
                <td>Before tax contribution (Salary sacrifice)</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResultCurrent.Inputs.CurrentVoluntaryConcessionalContributions), false) }} / year</td>
                <!-- <td>$0 / year</td> -->
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResult.AdditionalConcessionalContributions), false) }} / year</td>
              </tr>
              <tr>
                <td>After tax contributions</td>
                <td>${{ $formatCurrency(this.contributionEngineResultCurrent.Inputs.CurrentVoluntaryNonConcessionalContributions, false) }} / year</td>
                <!-- <td>$0 / year</td> -->
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions), false) }} / year</td>
              </tr>
              <tr>
                <td>Government co-contribution</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResultCurrent.CoContributionsBasedOnCurrentContributions), false) }} / year</td>
                <!-- <td>$0 / year</td> -->
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResult.CoContributionsBasedOnAdditionalContributions), false) }} / year</td>
              </tr>
              <tr>
                <td>Less contributions tax</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResultCurrent.ContributionsTaxOnEmployerContributions + this.contributionEngineResultCurrent.ContributionsTaxOnCurrentVoluntaryConcessionalContributions), false) }} / year</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResult.ContributionsTaxWithAdditionalVoluntaryContributions ), false) }} / year</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <th scope="row">Net contributions</th>
                <td>
                  ${{ $formatCurrency(
                  $roundTo(this.contributionEngineResultCurrent.EmployerConcessionalContributions) +
                  $roundTo(this.contributionEngineResultCurrent.Inputs.CurrentVoluntaryConcessionalContributions) +
                  $roundTo(this.contributionEngineResultCurrent.Inputs.CurrentVoluntaryNonConcessionalContributions) +
                  $roundTo(this.contributionEngineResultCurrent.CoContributionsBasedOnCurrentContributions)
                  -
                  $roundTo(this.contributionEngineResultCurrent.ContributionsTaxWithNoAdditionalVoluntaryContributions)
                  , false) }} / year

                  <!-- {{ $formatCurrency(
                  $roundTo(this.contributionEngineResult.EmployerConcessionalContributions) -
                  $roundTo(this.contributionEngineResult.ContributionsTaxOnEmployerContributions)
                  , false) }} / year -->
                </td>

                <td>${{ $formatCurrency(
                  $roundTo(this.contributionEngineResult.EmployerConcessionalContributions) +
                  $roundTo(this.contributionEngineResult.AdditionalConcessionalContributions) +
                  $roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions) +
                  $roundTo(this.contributionEngineResult.CoContributionsBasedOnAdditionalContributions)
                  -
                  $roundTo(this.contributionEngineResult.ContributionsTaxWithAdditionalVoluntaryContributions)
                  , false) }} / year
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <h3>Difference in net income after super contributions and tax.</h3>
        <!-- <h4>based on a contribution of <strong>$3,200 per year</strong></h4> -->
        <div class="table-responsive mb-4">
          <table class="table benefit-table">
            <thead>
              <tr>
                <th scope="col"><strong></strong></th>
                <th scope="col"><strong>With current contributions</strong></th>
                <th scope="col"><strong>With updated contributions</strong></th>

              </tr>
            </thead>

            <tbody>
              <tr>
                <td><strong>Gross salary</strong></td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResultCurrent.Inputs.AnnualSalary), false) }} / year</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResult.Inputs.AnnualSalary), false) }} / year</td>

              </tr>
              <tr>
                <td>Less salary sacrifice</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResultCurrent.Inputs.CurrentVoluntaryConcessionalContributions), false) }} / year</td>
                <!-- <td>$0 / year</td> -->
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResult.AdditionalConcessionalContributions), false) }} / year</td>
              </tr>
              <tr>
                <td>Less income tax + Medicare levy</td>
                <!-- confirm with Paul -->
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResultCurrent.CurrentIncomeTax), false) }} / year</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResult.IncomeTaxGivenAdditionalConcessionalContributions), false) }} / year</td>
              </tr>
              <tr>
                <td>Less after-tax contributions</td>
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResultCurrent.Inputs.CurrentVoluntaryNonConcessionalContributions), false) }} / year</td>
                <!-- <td>$0 / year</td> -->
                <td>${{ $formatCurrency($roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions), false) }} / year</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <th scope="row">Net income after superannuation & tax</th>
                <!-- todo -->
                <td>${{ $formatCurrency((
                  $roundTo(this.contributionEngineResultCurrent.Inputs.AnnualSalary) -
                  $roundTo(this.contributionEngineResultCurrent.Inputs.CurrentVoluntaryConcessionalContributions) -
                  $roundTo(this.contributionEngineResultCurrent.CurrentIncomeTax) -
                  $roundTo(this.contributionEngineResultCurrent.Inputs.CurrentVoluntaryNonConcessionalContributions)
                ), false) }} / year</td>

                <td>${{ $formatCurrency((
                  $roundTo(this.contributionEngineResult.Inputs.AnnualSalary) -
                  $roundTo(this.contributionEngineResult.AdditionalConcessionalContributions) -
                  $roundTo(this.contributionEngineResult.IncomeTaxGivenAdditionalConcessionalContributions) -
                  + $roundTo(this.contributionEngineResult.AdditionalNonConcessionalContributions)
                ), false) }} / year</td>
              </tr>
            </tfoot>
          </table>
          <div v-if="!this.taxedFund">
            <div v-html="clientConfig.content.calculation.untaxedFundDetailsFootnote"></div>
          </div>
        </div>

        <MDBBtn color="primary"
          class="btn btn-primary"
          aria-label="Reset button" @click="detailsModal = false">
          Close
        </MDBBtn>

      </MDBModalBody>
    </MDBModal>

    <MDBModal
      id="graphModal"
      tabindex="-1"
      labelledby="graphModalLabel"
      v-model="graphModal"
    >
      <MDBModalBody>
        <div class="graph">
          <MDBRow>
            <div class="col-4">
              <div aria-hidden="true" class="coin-wrapper">
                <div class="progress">
                  <div class="progress-bar bg-none" role="progressbar"></div>
                  <div class="progress-bar bg-legend-1" role="progressbar"></div>
                  <div class="progress-bar bg-legend-1" role="progressbar"></div>
                  <div class="progress-bar bg-legend-2" role="progressbar"></div>
                  <div class="progress-bar bg-legend-2" role="progressbar"></div>
                  <div class="progress-bar bg-legend-2" role="progressbar"></div>
                  <div class="progress-bar bg-legend-3" role="progressbar"></div>
                  <div class="progress-bar bg-legend-3" role="progressbar"></div>
                  <div class="progress-bar bg-legend-3" role="progressbar"></div>
                  <div class="progress-bar bg-legend-4" role="progressbar"></div>
                  <div class="progress-bar bg-legend-4" role="progressbar"></div>
                </div>
              </div>
            </div>

            <div class="col-8 legend-wrapper">
              <div class="legend">
                <div class="mt-4">
                  <h3>Your contribution details</h3>
                  <h4>Your extra contribution is made up of:</h4>
                </div>

                <table class="table benefit-table">
                  <tbody>
                    <tr>
                      <td class="item-1"><span class="swatch"></span>Employer contributions</td>
                      <td>$15,000</td>
                    </tr>
                    <tr>
                      <td class="item-2"><span class="swatch"></span>Before tax contribution (Salary sacrifice)*</td>
                      <td>$1,800</td>
                    </tr>
                    <tr>
                      <td class="item-3"><span class="swatch"></span>After tax contributions**</td>
                      <td>$1,600</td>
                    </tr>
                    <tr>
                      <td class="item-4"><span class="swatch"></span>Government co-contribution</td>
                      <td>$600</td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr>
                      <th scope="row">Net extra contribution (p.a.)</th>
                      <td>$19,996</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </MDBRow>

          <MDBBtn
            color="primary"
            class="btn btn-primary"
            aria-label="Reset button"
            @click="graphModal = false"
          >
            Close
          </MDBBtn>
        </div>
      </MDBModalBody>
    </MDBModal>

  </MDBContainer>
</template>